let $ = jQuery;

import {
	restCall,
	isEmpty,
	isDefined,
	debounce,
	addParametersToURL
} from './utilities.js';

export default class GenerateCodes {
	constructor(){
		// Check if it's the correct page
		if ( this.isTheCodesBatchGenerator() ){
			// Get elements
			this.getElements();

			// Get data
			this.getData();

			// Evaluate the visibility of the sections on page load
			this.updateUI();

			// Listen changes to the batch name field
			this.listenChangesToBatchName();

			// Listen changes to the dependency options
			this.listenChangesToDependencyOptions();

			// Listen changes to the LearnDash content options
			this.listenChangesToLearnDashContent();

			// Listen changes to the generation method options
			this.listenChangesToGenerationMethod();

			// Listen changes to the "Number of uses per code" field
			this.listenChangesToNumberOfUsesPerCode();

			// Create select2 fields
			this.initSelect2Fields();
		}	
	}

	getElements(){
		this.$elements = {
			container:         $( '#uoc-generate' ),

			batchName:         $( '#uoc-generate-batch-name' ),
			batchNameError:    $( '#uoc-generate-batch-name-error' ),
			batchNameContainer:$( '#uoc-generate-batch-name-container' ),

			select2Fields:     $( '.uoc-generate--select2-js' ),

			dependencyOptions: $( '.uoc-generate-dependency-option--js' ),
			dependencyLearnDashContent: $( '.uoc-generate-dependency-ld-content-option--js' ),
			generationMethod:  $( '.uoc-generate-generation-method--js' ),
			numberOfUsesPerCode: $( '#uoc-generate-coupon-max-usage' ),

			submitButton:      $( '#uoc-generate-submit-button' ),

			allFieldsWithDynamicRequiredProp: $( '#uoc-generate input:not(.uoc-generate--always-required-js), #uoc-generate select:not(.uoc-generate--always-required-js), #uoc-generate textarea:not(.uoc-generate--always-required-js)' ),

			sections: {
				dependencyLearnDash:        $( '#uoc-generate-dependency-specific-learndash' ),
				dependencyLearnDashCourses: $( '#uoc-generate-dependency-specific-learndash-courses' ),
				dependencyLearnDashGroups:  $( '#uoc-generate-dependency-specific-learndash-groups' ),
				codeSetup:                  $( '#uoc-generate-code-setup' ),
				creationMethodAuto:         $( '#uoc-generate-generation-method-auto' ),
				creationMethodManual:       $( '#uoc-generate-generation-method-manual' ),
			},

			notices: {
				youMustInstallAutomator: $( '#uoc-generate-dependency-automator-install' ),
				youMustUpdateAutomator: $( '#uoc-generate-dependency-automator-update' ),
				automatorNextStep: $( '#uoc-generate-dependency-automator-what-now' ),
				youMustInstallLearnDash: $( '#uoc-generate-dependency-learndash-install' ),
				codeMaxUsageWooCommerce: $( '#uoc-generate-code-setup-max-usage-woocommerce-notice' )
			}
		}
	}

	getData(){
		this.data = {
			isFirstStepReady: false,
			selectedData: {
				dependency:          null,
				learnDashContent:    null,
				generationMethod:    null,
				numberOfUsesPerCode: null
			},
			dynamicRequiredFields: {
				learndash: {
					always: [
						'learndash-content',
						'learndash-code-type'
					],
					whenSelectingCourses: [
						'learndash-courses[]'
					],
					whenSelectingGroups: [
						'learndash-groups[]'
					]
				},
				generationMethod: {
					auto: [
						'coupon-amount',
						'coupon-length',
						'coupon-dash'
					],
					manual: [
						'manual-codes'
					]
				}
			},
			batchNameRestCall: null,
			batchNameRestCallInProgress: false,
			batchNameIsUnique: UncannyCodes.generate.mode == 'edit' ? true : false,
		}

		// Get data from fields on page load
		this.updateSelectedDependency();
		this.updateSelectedLearnDashContent();
		this.updateSelectedGenerationMethod();
		this.updateSelectedNumberOfUsesPerCode();

		this.updateIsFirstStepReady();
	}

	initSelect2Fields(){
		// Check if select2 is ready
		if ( $.fn.select2 ){
			// Start select2
			this.$elements.select2Fields
				.select2({
					theme: 'uoc-select2',
					language: {
						noResults: function(){
							return UncannyCodes.generate.i18n.noResults;
						},
					},
				});
		}
	}

	updateUI(){
		// First, hide all of them
		Object.values( this.$elements.sections ).forEach(( section ) => {
			// Hide it
			$( section ).hide();
		});

		Object.values( this.$elements.notices ).forEach(( notice ) => {
			// Hide it
			$( notice ).hide();
		});

		// Check if the LearnDash dependency is selected
		if ( this.data.selectedData.dependency == 'learndash' ){
			// Check if LearnDash is installed
			if ( UncannyCodes.generate.hasLearnDashInstalled ){
				// Show the LearnDash section
				this.$elements.sections.dependencyLearnDash.show();
			}
			else {
				// Show the "you must install" LearnDash notice
				this.$elements.notices.youMustInstallLearnDash.show();
			}

			// Update the text of the submit button
			this.$elements.submitButton.val( UncannyCodes.generate.i18n.submitButton.forLearnDash );
		}

		// Check if the LearnDash dependency > courses is selected
		if ( this.data.selectedData.learnDashContent == 'learndash-courses' ){
			// Show the courses field
			this.$elements.sections.dependencyLearnDashCourses.show();
		}

		// Check if the LearnDash dependency > groups is selected
		if ( this.data.selectedData.learnDashContent == 'learndash-groups' ){
			// Show the groups field
			this.$elements.sections.dependencyLearnDashGroups.show();
		}

		// Check if the Automator dependency is selected
		if ( this.data.selectedData.dependency == 'automator' ){
			// Check if Automator is installed
			if ( UncannyCodes.generate.hasAutomatorInstalled ){
				// Check if we have to update Automator first
				if ( UncannyCodes.generate.hasToUpdateAutomator ){
					// Check if we they have to update Automator first
					this.$elements.notices.youMustUpdateAutomator.show();
				}
				else {
					// Show the "what next" Automator section
					this.$elements.notices.automatorNextStep.show();
				}	
			}
			else {
				// Show the "you must install" Automator notice
				this.$elements.notices.youMustInstallAutomator.show();
			}

			// Update the text of the submit button
			this.$elements.submitButton.val( UncannyCodes.generate.i18n.submitButton.forAutomator );

				
			if (
				// Check if WC is installed
				UncannyCodes.generate.hasWooCommerceInstalled
				// Check if "Number of uses per code" if greater than 1
				&& this.data.selectedData.numberOfUsesPerCode > 1
			){
				// Show the WooCommerce warning
				this.$elements.notices.codeMaxUsageWooCommerce.show();
			}
		}

		// Check if the user is in edit mode
		if ( UncannyCodes.generate.mode == 'edit' ){
			// Update the text of the submit button
			this.$elements.submitButton.val( UncannyCodes.generate.i18n.submitButton.modifyBatch );
		}

		// Check if the generation method "auto" is selected
		if ( this.data.selectedData.generationMethod == 'auto' ){
			// Show the auto section
			this.$elements.sections.creationMethodAuto.show();
		}

		// Check if the generation method "manual" is selected
		if ( this.data.selectedData.generationMethod == 'manual' ){
			// Show the manual section
			this.$elements.sections.creationMethodManual.show();
		}

		// Check if the first step is ready so we can
		// show the second one: "Code setup"
		if ( this.data.isFirstStepReady ){
			// Show the code setup step
			this.$elements.sections.codeSetup.show();
		}
		else {
			this.$elements.sections.codeSetup.hide();
		}

		this.updateRequiredFields();
	}

	updateRequiredFields(){
		// First, make all the fields not required
		this.$elements.allFieldsWithDynamicRequiredProp.prop( 'required', false );

		// Get list of required fields
		let requiredFields = [];

		// Check what fields should always be required
		if ( this.data.selectedData.dependency == 'learndash' ){
			// Check what fields should always be required for LearnDash
			requiredFields.push( ...this.data.dynamicRequiredFields.learndash.always );

			// Check if the LearnDash dependency > courses is selected
			if ( this.data.selectedData.learnDashContent == 'learndash-courses' ){
				// Add the required fields for this section
				requiredFields.push( ...this.data.dynamicRequiredFields.learndash.whenSelectingCourses );
			}

			// Check if the LearnDash dependency > groups is selected
			if ( this.data.selectedData.learnDashContent == 'learndash-groups' ){
				// Add the required fields for this section
				requiredFields.push( ...this.data.dynamicRequiredFields.learndash.whenSelectingGroups );
			}
		}

		// Check what generation method is selected
		if ( this.data.selectedData.generationMethod == 'auto' ){
			// Add the required fields for this section
			requiredFields.push( ...this.data.dynamicRequiredFields.generationMethod.auto );
		}

		if ( this.data.selectedData.generationMethod == 'manual' ){
			// Add the required fields for this section
			requiredFields.push( ...this.data.dynamicRequiredFields.generationMethod.manual );
		}

		// Check what fields should always be required for LearnDash
		requiredFields.forEach(( fieldName ) => {
			// Find fields that should be required
			this.$elements.allFieldsWithDynamicRequiredProp
			    .filter( `input[name="${ fieldName }"], select[name="${ fieldName }"], textarea[name="${ fieldName }"]` )
			    .prop( 'required', true );
		});
	}

	listenChangesToDependencyOptions(){
		// Listen changes to the dependency options
		this.$elements.dependencyOptions.on( 'change', () => {
			// Update the selected dependency
			this.updateSelectedDependency();

			// Evaluate visibility
			this.updateUI();
		});
	}

	listenChangesToLearnDashContent(){
		// Listen changes to the learndash content options
		this.$elements.dependencyLearnDashContent.on( 'change', () => {
			// Update the selected learndash conten
			this.updateSelectedLearnDashContent();

			// Evaluate visibility
			this.updateUI();
		});
	}

	listenChangesToGenerationMethod(){
		// Listen changes to the generation method options
		this.$elements.generationMethod.on( 'change', () => {
			// Update the selected generation method
			this.updateSelectedGenerationMethod();

			// Evaluate visibility
			this.updateUI();
		});
	}

	listenChangesToNumberOfUsesPerCode(){
		// Listen changes to the "Number of uses per code" field
		this.$elements.numberOfUsesPerCode.on( 'input', debounce( () => {
			// Update the selected generation method
			this.updateSelectedNumberOfUsesPerCode();

			// Evaluate visibility
			this.updateUI();
		}, 200 ));
	}

	listenChangesToBatchName(){
		// Listen changes to the "Name this batch of codes" field
		this.$elements.batchName.on( 'input', () => {
			// Remove the loading animation from the field
			this.$elements.batchNameContainer
				.removeClass( 'uoc-generate-section-form-field--loading' );
		});

		// Listen changes to the "Name this batch of codes" field
		this.$elements.batchName.on( 'input', debounce( () => {
			// Check if the title is available
			this.checkIfBatchNameIsAvailable();
		}, 500 ));
	}

	updateSelectedDependency(){
		// Default response
		let response = null;

		// Get the selected option
		const $selectedOption = this.$elements.dependencyOptions.filter( ':checked' );

		// Check if there is one
		if ( $selectedOption.length > 0 ){
			response = $selectedOption.val();

			// Add the selected dependency to the URL
			addParametersToURL( '', {
				dependency: response
			}, {
				setAsURL: true,
			});
		}

		// Update the saved data
		this.data.selectedData.dependency = response;

		// Update if the first step is ready
		this.updateIsFirstStepReady();

		return response;
	}

	updateSelectedLearnDashContent(){
		// Default response
		let response = null;

		// Get the selected option
		const $selectedOption = this.$elements.dependencyLearnDashContent.filter( ':checked' );

		// Check if there is one
		if ( $selectedOption.length > 0 ){
			response = $selectedOption.val();
		}

		// Update the saved data
		this.data.selectedData.learnDashContent = response;

		// Update if the first step is ready
		this.updateIsFirstStepReady();

		return response;
	}

	updateSelectedGenerationMethod(){
		// Default response
		let response = null;

		// Get the selected option
		const $selectedOption = this.$elements.generationMethod.filter( ':checked' );

		// Check if there is one
		if ( $selectedOption.length > 0 ){
			response = $selectedOption.val();
		}

		// Update the saved data
		this.data.selectedData.generationMethod = response;

		// Update if the first step is ready
		this.updateIsFirstStepReady();

		return response;
	}

	updateSelectedNumberOfUsesPerCode(){
		// Default response
		let response = parseInt( this.$elements.numberOfUsesPerCode.val() );

		// Update the saved data
		this.data.selectedData.numberOfUsesPerCode = response;

		return response;
	}

	updateIsFirstStepReady(){
		// Default response
		let response = null;

		// The first step will be ready if:
		response = (
			// Check if the batch name is unique
			this.data.batchNameIsUnique

			&& (
				// Automator is selected and...
				(
					this.data.selectedData.dependency == 'automator'
					// is also installed
					&& UncannyCodes.generate.hasAutomatorInstalled
					// and doesn't have to update it
					&& ! UncannyCodes.generate.hasToUpdateAutomator
				)

				// Or LearnDash is selected and...
				|| (
					this.data.selectedData.dependency == 'learndash' 
					// is also installed, and...
					&& UncannyCodes.generate.hasLearnDashInstalled

					// has a LearnDash content selected
					&& ! isEmpty( this.data.selectedData.learnDashContent )
				)
			)
		);

		// Update if the first step is ready
		this.data.isFirstStepReady = response;

		return response;
	}

	checkIfBatchNameIsAvailable(){
		// Get the current value
		const batchName = this.$elements.batchName.val();

		// Remove errors
		this.$elements.batchNameError
			.text( '' );

		// Remove success class
		this.$elements.batchNameContainer
			.removeClass( 'uoc-generate-section-form-field--success' );

		// Update batchNameIsUnique
		this.data.batchNameIsUnique = false;

		if ( ! isEmpty( batchName ) ){
			// Check if we're already checking for the response
			if ( 
				this.data.batchNameRestCallInProgress 
				&& isDefined( this.data.batchNameRestCall )
			){
				// Abort the call
				this.data.batchNameRestCall.abort();
			}

			// Start loading animation
			this.$elements.batchNameContainer
				.addClass( 'uoc-generate-section-form-field--loading' );

			// Do the call
			this.data.batchNameRestCall = restCall(
				// Endpoint
				'group_batch_has_name',
				// Data
				{
					batch_name: batchName
				},
				// On success
				( response ) => {
					// Stop loading animation
					this.$elements.batchNameContainer
						.removeClass( 'uoc-generate-section-form-field--loading' );

					// Check if it's available
					if ( response.is_available ){
						// Add the success class
						this.$elements.batchNameContainer
							.addClass( 'uoc-generate-section-form-field--success' );

						// Update batchNameIsUnique
						this.data.batchNameIsUnique = true;
					}
					else {
						this.$elements.batchNameError
							.text( UncannyCodes.generate.i18n.batchName.errors.nameExists );
					}

					this.updateIsFirstStepReady();

					// Evaluate visibility
					this.updateUI();
				},
				( response ) => {
					// Stop loading animation
					this.$elements.batchNameContainer
						.removeClass( 'uoc-generate-section-form-field--loading' );

					// Check if there is a message
					if ( isDefined( response.message ) ){
						this.$elements.batchNameError
							.text( response.message );
					}
					else {
						this.$elements.batchNameError
							.text( UncannyCodes.generate.i18n.somethingWentWrong );
					}
				}
			);
		}
		else {
			this.updateIsFirstStepReady();

			// Evaluate visibility
			this.updateUI();
		}
	}

	isTheCodesBatchGenerator(){
		return $( '#uoc-generate' ).length == 1;
	}
}